import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'default-passive-events';
import './assets/css/before.css';
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.use(VueQuillEditor);
Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
}).$mount('#app')
